import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_mst_item_event_RowClass } from '../../../dbschema/bl_inv_mst_item_event.model';

export class InventoryItemEventContainerModel extends BaseContainerModel {
  bl_inv_mst_item_event: bl_inv_mst_item_event_RowClass = new bl_inv_mst_item_event_RowClass();
}


